import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import { georgeWebHeaderStore } from "components/common/GeorgeWebHeader";
import auth from "stores/AuthStore";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { AssetCalculationRoutes } from "./AssetCalculationRoutes";
import { AssetCalculationStore } from "./AssetCalculationStore";
import { AssetCalculationOverview } from "./AssetCalculationOverview";

type IProps = RouteComponentProps & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export default class AssetCalculationContainer extends React.Component<IProps> {
    store: AssetCalculationStore;

    constructor(props: IProps) {
        super(props);
        this.store = new AssetCalculationStore();
    }

    async componentDidMount() {
        pushRoute(AssetCalculationRoutes.ROOT);
        try {
            await this.store.loadData();
        } catch (error) {
            debug.log("### AssetCalculationContainer.componentDidMount() Failed to load data", error);

            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    render() {
        document.title = ui.__("assetCalculation.document.title");
        return (
            <div>
                <Route exact path={AssetCalculationRoutes.ROOT} component={this.withStore(AssetCalculationOverview)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/assetCalculation/AssetCalculationContainer.tsx